import { Button, ToastMessage } from '@cokitchen/cokitchen-components';
import React, { FC, useState } from 'react';

import LocalModal from 'components/base/local-modal';
import { ReactComponent as CopyIcon } from 'assets/icons/copy.svg';
import { apiService } from 'services/base.service';
import { toast } from 'react-toastify';
import { RmxCheckIcon } from 'cokitchen-icons';
import { handleApiError } from 'utils/functions';

type ComplaintModalProps = {
  show: boolean;
  onClose: () => void;
};

const reasons = [
  'Delayed delivery',
  'Incorrect item received',
  'Spilled items',
  'Missing items',
  'Discount code not applied',
  'Reccurently order not followed correctly'
];

const ComplaintModal: FC<ComplaintModalProps> = ({ show, onClose }) => {
  const [copied, setCopied] = useState(false);
  const handleClose = () => {
    onClose();
  };
  const phoneNumber = '0815761902';
  const [feedback, setFeedback] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    const data = {
      feedback
    };
    try {
      setLoading(true);
      const res = await apiService.post('app-feedback', {
        data,
        baseURL: process.env.REACT_APP_CORE_API_URL
      });
      if (res) {
        toast(<ToastMessage type='success' message='We appreciate your feedback' />);
        setFeedback('');
        onClose();
      }
    } catch (err) {
      handleApiError(err, 'Failed to submit feedback');
    } finally {
      setLoading(false);
    }
  };
  const handleCopy = () => {
    const tempInput = document.createElement('input');
    tempInput.value = phoneNumber;
    document.body.appendChild(tempInput);

    const range = document.createRange();
    range.selectNode(tempInput);
    window.getSelection()?.removeAllRanges();
    window.getSelection()?.addRange(range);

    document.execCommand('copy');
    window.getSelection()?.removeAllRanges();
    document.body.removeChild(tempInput);
    setCopied(true);
    setTimeout(() => {
      setCopied(false);
    }, 5000);
  };

  return (
    <LocalModal
      isOpen={show}
      onRequestClose={handleClose}
      title='Need help'
      contentClassName='sm:!max-w-[400px]'>
      <div className='flex flex-col gap-4'>
        <p className='text-center text-gray-3 pb-2 text-sm whitespace-nowrap'>
          Got a complaint about your order?
        </p>
        <ul className='flex flex-col gap-3'>
          {reasons.map((reason, index) => (
            <li
              key={index}
              className='flex items-center justify-between gap-3 px-4 py-3 rounded-md cursor-pointer select-none'
              onClick={() => setFeedback(reason)}>
              <p className='text-sm font-medium'>{reason}</p>
              <span
                className={`shrink-0 w-[10px] h-[10px] rounded-full ${
                  feedback === reason
                    ? 'outline outline-2 outline-offset-2 bg-[#F73B58] outline-[#FA8596]'
                    : 'outline outline-2 outline-offset-2 outline-[#D8D9DA]'
                }`}
              />
            </li>
          ))}
        </ul>

        <div className='flex items-center'>
          <p className='text-gray-3 text-sm'>Contact Support instead</p>
          <span
            onClick={handleCopy}
            className='ml-auto cursor-pointer whitespace-nowrap text-sm flex items-center'>
            {phoneNumber}{' '}
            {copied ? (
              <RmxCheckIcon className=' text-red-5 ml-2' />
            ) : (
              <CopyIcon className='hover:bg-red-1 ml-2' />
            )}
          </span>
        </div>
      </div>
      <div className='mt-10 flex justify-end'>
        <Button
          color='gray'
          variant='block'
          className='mr-4 w-[139px] h-[41px]'
          onClick={handleClose}>
          Cancel
        </Button>
        <Button
          color='primary'
          variant='block'
          className='w-[139px] h-[41px]'
          loading={loading}
          onClick={handleSubmit}
          disabled={!feedback}>
          Confirm
        </Button>
      </div>
    </LocalModal>
  );
};

export default ComplaintModal;
